//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';

const InsertRateLimit = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertRateLimit,
        method: RequestType.POST,
        data,
    });

const GlobalSmsRateLimitCommand = {
    InsertRateLimit,
};

export default GlobalSmsRateLimitCommand;

